import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CuentasPorCobrarService } from '../../../../../services/cuentas-por-cobrar.service';

declare var $;

@Component({
  selector: 'app-formulario-renta',
  templateUrl: './formulario-renta.component.html',
  styleUrls: ['./formulario-renta.component.scss']
})
export class FormularioRentaComponent implements OnInit {
    
    public errors: any = {};
    public puntosINPC: any [] = [];
    public periodos: any [] = [];
    public unidadesIncremento: any [] = [];
    public contratos: any [] = [];
    public interes_moratorio: any = {};
    public periodicidad: any = {};
    public interes_moratorio_unidad: any = {};
    public inpc_puntos: any = {};
    public concepto:any = {};
    public conceptos:any = [];
    public loading_conceptos:boolean = false;

    @Output() rentaGuardada: EventEmitter<any> = new EventEmitter;
    @Input() public renta: any={};
    @Input() public contrato: any = {};

    constructor(private cuentasPorCobrarService: CuentasPorCobrarService) {
    }

    ngOnInit() {
      this.loadPuntosINPC();
      this.loadPeriodos();
      this.loadUnidadesIncremento();
      this.loadConceptos();
    }

    loadPuntosINPC(){
      for(var i=1; i<=10; i++){
        this.puntosINPC.push({id: i, cantidad: i});
      }
    }

    loadConceptos(){
      this.loading_conceptos = true;
      this.cuentasPorCobrarService.getAllConceptosVisiblesEnContratos()
      .subscribe(
        (response)=>{
          let content = response.json().content;
          this.conceptos = content;
          this.loading_conceptos = false;
        },
        (error)=>{
          this.loading_conceptos = false;
        }
      );
    }

    loadPeriodos(){
      this.periodos.push({id: 1, descripcion: "Semanal"});
      this.periodos.push({id: 2, descripcion: "Quincenal"});
      this.periodos.push({id: 3, descripcion: "Mensual"});
      this.periodos.push({id: 4, descripcion: "Bimestral"});
      this.periodos.push({id: 5, descripcion: "Trimestral"});
      this.periodos.push({id: 6, descripcion: "Semestral"});
      this.periodos.push({id: 7, descripcion: "Anual"});
      this.changePeriodicidad(this.periodos[2]);
    }

    loadUnidadesIncremento(){
      this.unidadesIncremento.push({id:"DIAS",descripcion:"DÍAS"});
    this.unidadesIncremento.push({id:"SEMANAS",descripcion:"SEMANAS"});
    this.unidadesIncremento.push({id:"MESES",descripcion:"MESES"});
      this.changeInteresMoratorioUnidad(this.unidadesIncremento[0]);
    }
    
    loadRenta(renta){
      this.renta = renta;

      if(this.renta.periodicidad){
        for(var i=0;i<this.periodos.length;i++){
          var periodo = this.periodos[i];
          if(periodo.descripcion.toLowerCase()==this.renta.periodicidad){
            this.periodicidad = periodo;
            this.changePeriodicidad(this.periodicidad);
          }
        }
      }

      if(this.renta.id_concepto && this.renta.id_concepto!=null && this.renta.id_concepto!=0){
        for(var i=0;i<this.conceptos.length;i++){
          var concepto = this.conceptos[i];
          if(concepto.idConceptos==this.renta.id_concepto){
            this.concepto = concepto;
          }
        }
      }else{
        this.concepto = {};
      }

      if(this.renta.incremento_inpc===true && this.renta.puntos_inpc_renovacion){
        for(var i=0;i<this.puntosINPC.length;i++){
          var puntaje_inpc = this.puntosINPC[i];
          if(puntaje_inpc.cantidad===this.renta.puntos_inpc_renovacion){
            this.inpc_puntos = puntaje_inpc;
          }
        }
      }
    }
    agregarInteresMoratorio(){
      this.renta.intereses_moratorios.push(this.interes_moratorio);
      this.interes_moratorio = {};
      this.changeInteresMoratorioUnidad(this.unidadesIncremento[0]);
    }

    guardarRenta(){
      if(!this.validar()) return false;
      //Enviar renta al padre para que la agregue a su arreglo de rentas y al server
      if(this.rentaGuardada){
        this.rentaGuardada.emit(this.renta);
        this.renta = {
          intereses_moratorios: [],
          incremento_inpc: false,
          activo: true,
          periodicidad: {}
        };
      }
    }

    validar(){
      var valid = true;
      this.errors = [];
      this.errors = this.cuentasPorCobrarService.validarInfoRenta(this.renta);
      if (!$.isEmptyObject(this.errors)) {
        valid = false;
      }
      return valid;
    }

    eliminarInteresMoratorio(index){
      for(var i=0;i<this.renta.intereses_moratorios.length; i++){
        if(i == index){
          this.renta.intereses_moratorios.splice(i,1);
        }
      }
    }

    changePeriodicidad($event){
      this.periodicidad = $event;
      this.renta.periodicidad = this.periodicidad.descripcion;
    }

    changeConceptoSelected($event){
      this.concepto = $event;
      this.renta.id_concepto = this.concepto.idConceptos;
    }

    changeInteresMoratorioUnidad($event){
      this.interes_moratorio_unidad = $event;
      this.interes_moratorio.unidad = this.interes_moratorio_unidad.id;
    }

    changeINPCPuntaje($event){
      this.inpc_puntos = $event;
      this.renta.puntos_inpc_renovacion = this.inpc_puntos.cantidad;

    }

    loadContrato(){
      //Por defecto, ponerle a la renta el inicio y fin del contrato
      this.renta.fecha_inicio = this.contrato.fecha_inicio;
      this.renta.fecha_fin = this.contrato.fecha_fin;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/contratos/agregar-contrato/listado-rentas/formulario-renta/formulario-renta.component.ts